import React from 'react';
import { observer } from 'mobx-react';
import { WeaTimeRangePicker } from 'ecCom';

@observer
export default class TimeRangePickerNew extends React.Component<any, any>{

    onChange = (v) => {
        const {onChange,fieldid, isChild} = this.props;
        onChange(fieldid,v,isChild);
    }

    render() {
        return <WeaTimeRangePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaTimeRangePicker@8tlqvx`} 
            {...this.props}
            onChange={this.onChange}
        ></WeaTimeRangePicker>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/commonComs/TimeRangePickerNew.tsx